import { useRef } from 'react'
import { useFrame, useThree } from '@react-three/fiber'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { useGSAP } from '@gsap/react'
import * as THREE from 'three'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(useGSAP)

const cameraTarget = new THREE.Vector3(0, 0, 0)

export default function CameraAnimation() {
  const camera = useThree((state) => state.camera)
  const tlRef = useRef(gsap.timeline())

  useFrame(() => {
    camera.lookAt(cameraTarget)
  })

  useGSAP(() => {
    const tl = tlRef.current

    tl.from(cameraTarget, {
      x: 0,
      y: 0,
      z: -4.579,
      duration: 4.5,
      ease: 'power2.inOut',
    })

    tl.to(
      '.section-1',
      {
        opacity: 0,
        scrollTrigger: {
          trigger: '.section-2',
          start: 'top bottom',
          end: 'top 30%',
          scrub: 0.5,
        },
      },
      '<'
    )

    // Section 2
    tl.fromTo(
      camera.position,
      { x: 6.874, y: -0.112, z: 0.388 },
      {
        x: 1.904, y: 0.294, z: 3.409,
        ease: 'power2.inOut',
        scrollTrigger: {
          trigger: '.section-2',
          start: 'top bottom',
          end: 'bottom bottom',
          scrub: 0.5,
        },
      }
    )

    // Section 3
    tl.fromTo(
      camera.position,
      { x: 1.904, y: 0.294, z: 3.409 },
      {
        x: 3.065,
        y: -2.011,
        z: -5.506,
        duration: 2.5,
        ease: 'power2.inOut',
        immediateRender: false,
        scrollTrigger: {
          trigger: '.section-3',
          start: 'top bottom',
          end: 'bottom bottom',
          scrub: 0.5,
        },
      }
    )

    // Section 4
    tl.fromTo(
      camera.position,
      { x: 3.065, y: -2.011, z: -5.506 },
      {
        x: 4.755,
        y: 0.833,
        z: 5.639,
        ease: 'power2.inOut',
        immediateRender: false,
        scrollTrigger: {
          trigger: '.section-4',
          start: 'top bottom',
          end: 'bottom bottom',
          scrub: 0.5,
        },
      }
    )

    // Section 5
    tl.fromTo(
      camera.position,
      { x: 4.755, y: 0.833, z: 5.639 },
      {
        x: -6.975,
        y: 0.008,
        z: -0.562,
        ease: 'power2.inOut',
        immediateRender: false,
        scrollTrigger: {
          trigger: '.section-5',
          start: 'top bottom',
          end: 'bottom bottom',
          scrub: 0.5,
        },
      }
    )

    // Section 6
    tl.fromTo(
      camera.position,
      { x: -6.975, y: 0.008, z: -0.562 },
      {
        x: -6.791,
        y: -1.680,
        z: -0.205,
        ease: 'power2.inOut',
        immediateRender: false,
        scrollTrigger: {
          trigger: '.section-6',
          start: 'top bottom',
          end: 'bottom bottom',
          scrub: 0.5,
        },
      }
    )
  }, [])

  return null
}
